export const SET_USER = 'SET_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const LOGOUT_USER = 'LOGOUT_USER';
export const API_TOKEN = "api_token";
export const FOOTER = "Footer";
// export const PURGE = 'PURGE';
// export const REHYDRATE = 'persist/REHYDRATE';

export const CHANGE_SETTING = 'CHANGE_SETTING';

export const SET_MESSAGES = 'SET_MESSAGES';
export const READ_MESSAGE = 'READ_MESSAGE';

export const ADD_COMPLAIN = 'ADD_COMPLAIN';
export const UPDATE_COMPLAIN = 'UPDATE_COMPLAIN';
export const RESET_COMPLAIN = 'RESET_COMPLAIN';

export const UPDATE_FOOTER = 'UPDATE_FOOTER';


